import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import type { ActivityRating } from '@/api/types/jobEnd.types';
import {
  ACTIVITY_LABELS_SHORT,
  ACTIVITY_RATING_ABBREVIATIONS,
} from '@/components/job-ends/natureOfRoleLabels';

interface ProjectRolesTableProps {
  activityRatings: ActivityRating[] | null;
  isComplete: boolean;
}

export function ProjectRolesTable({ activityRatings, isComplete }: ProjectRolesTableProps) {
  if (!isComplete || !activityRatings || activityRatings.length === 0) {
    return null;
  }

  return (
    <>
    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
      Project Roles
    </Typography>
    <TableContainer sx={{ mb: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {activityRatings.map(({ activityType }) => (
              <TableCell key={activityType} align="center">
                {ACTIVITY_LABELS_SHORT[activityType]}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {activityRatings.map(({ activityType, rating }) => (
              <TableCell key={activityType} align="center">
                {rating ? ACTIVITY_RATING_ABBREVIATIONS[rating] : '—'}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
}

export default ProjectRolesTable;
